import {
  USERS_REQUEST,
  USERS_SUCCESS,
  USERS_FAILURE,
  USER_REQUEST,
  USER_SUCCESS,
  USER_FAILURE,
  USER_UPDATE_REQUEST,
  USER_UPDATE_SUCCESS,
  USER_UPDATE_FAILURE,
  USER_ACTIVITY_REQUEST,
  USER_ACTIVITY_SUCCESS,
  USER_ACTIVITY_FAILURE,
  USERS_TYPEAHEAD_REQUEST,
  USERS_TYPEAHEAD_SUCCESS,
  USERS_TYPEAHEAD_FAILURE,
  USERS_DOWNLOAD_REQUEST,
  USERS_DOWNLOAD_SUCCESS,
  USERS_DOWNLOAD_FAILURE
} from "./UsersActions";

const initialState = {
  users: [],
  users_typeahead: [],
  downloadUsers: [],
  user: {},
  error: null,
  audits: [],
  isAuditLoading: false,
  isLoading: false
}

export default function userReducer(state = initialState, { type, payload, data } ){
  switch (type) {
    case USERS_REQUEST:
      return { ...state, isLoading: true };
    case USERS_SUCCESS:
      return { ...state, users: payload.data, user: {}, error: null, isLoading: false };
    case USERS_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case USER_REQUEST:
      return { ...state, isLoading: true };
    case USER_SUCCESS:
      return { ...state, user: payload.data, errors: null, isLoading: false };
    case USER_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case USER_UPDATE_REQUEST:
      return { ...state, isLoading: true };
    case USER_UPDATE_SUCCESS:
      return { ...state, user: payload.data, error: null, isLoading: false };
    case USER_UPDATE_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case USERS_TYPEAHEAD_REQUEST:
      return { ...state, isLoading: true };
    case USERS_TYPEAHEAD_SUCCESS:
      return { ...state, users_typeahead: payload.data, error: null, isLoading: false };
    case USERS_TYPEAHEAD_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case USER_ACTIVITY_REQUEST:
      return { ...state, isAuditLoading: true };
    case USER_ACTIVITY_SUCCESS:
      return { ...state, audits: payload.data, error: null, isAuditLoading: false };
    case USER_ACTIVITY_FAILURE:
      return { ...state, error: payload.error, isAuditLoading: false };

    case USERS_DOWNLOAD_REQUEST:
      return { ...state, isLoading: true };
    case USERS_DOWNLOAD_SUCCESS:
      return { ...state, downloadUsers: payload.data, user: {}, error: null, isLoading: false };
    case USERS_DOWNLOAD_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/users/UsersReducer.js